export default class PayExemption {
    // CON-451: el descuento se identifica por su Guid (id de ProcessConfigurationPayExemption),
    // no por el antiguo bit `type`. Se conserva `type` solo para excluir None/NoReason en la vista.
    private _id: string;
    private _type: BigInt | null;
    private _text: string;
    private _value: boolean;
    private _amount: number | null;

    public constructor(data: any) {
        this._id = data.id;
        this._text = data.text;
        this._value = data.value;
        this._type = data.type;
        this._amount = data.amount;
    }

    public get id() {
        return this._id;
    }

    public get type() {
        return this._type;
    }

    public get text() {
        return this._text;
    }

    public get value() {
        return this._value;
    }
    public set value(newValue: boolean) {
        this._value = newValue;
    }
    public get amount() {
        return this._amount;
    }
    public set amount(newamount: number | null) {
        this._amount = newamount;
    }
    public toServer() {
        return {
            payExemptionType: this._id,
            amount: this._amount
        };
    }
}
